import { render } from "./Theme.vue?vue&type=template&id=ec48ec82&scoped=true"
import script from "./Theme.vue?vue&type=script&lang=js"
export * from "./Theme.vue?vue&type=script&lang=js"

import "./Theme.vue?vue&type=style&index=0&id=ec48ec82&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec48ec82"]])

export default __exports__